import { Adjust } from '@adjustcom/adjust-web-sdk';
import { ReactNode, useEffect, useState } from 'react';
import { AdjustProvider } from '../adjustContext';
import { ADJUST_EVENTS } from '../analytics';
import useLoadTracking from './useLoadTracking';

const AdjustTracking = ({ children }: { children: JSX.Element }) => {
  const { load } = useLoadTracking();
  return <AdjustWrapper load={load}>{children}</AdjustWrapper>;
};

const AdjustWrapper = ({ children, load }: { children: ReactNode; load: boolean }) => {
  const [adjust, setAdjust] = useState<Adjust>();
  useEffect(() => {
    const loadAdjust = async () => {
      const adjust = await import('../adjust');
      adjust.default.trackEvent({
        eventToken: ADJUST_EVENTS.webSessionStart.token,
      });
      setAdjust(adjust.default);
    };
    if (load) {
      loadAdjust();
    }
  }, [load]);
  return <AdjustProvider value={adjust}>{children}</AdjustProvider>;
};

export default AdjustTracking;
